import React from "react";
import { candidateShortlist } from "../candidateShortlist";
import ShortlistCandidateItem from "./ShortlistCandidateItem/ShortlistCandidateItem";
import { ycAdmissionsTeamAsCandidates } from "assets/ycAdmissionsTeamAsCandidates";

export default function ShortlistCandidates() {
  return (
    <div className="mb-[100px] py-[150px] bg-black">
      <section className="px-6">
        {ycAdmissionsTeamAsCandidates.map((candidate) => (
          <ShortlistCandidateItem candidate={candidate} />
        ))}
      </section>
    </div>
  );
}
